import { RCBanner } from '@reverbdotcom/cadence/components';
import React from 'react';
import I18n from 'i18n-js';
import SpeakerIcon from '@reverbdotcom/cadence/images/brand/report-orange.svg';

export default function BillingMethodNeededBanner() {

  return (
    <RCBanner
      title={I18n.t('discovery.payStatement.billingMethodNeededBanner.headline')}
      content={I18n.t('discovery.payStatement.billingMethodNeededBanner.message')}
      image={SpeakerIcon}
      theme="info"
    />
  );
}
